export enum SubscriptionTypes {
    ViewModel = 6,
    DashboardUpdate = 16,
    DeviceStatus = 9
}
